

<template>
<div class="container" v-if="articles">
    <div v-if="articles[0]" class="featured-news">
      <a :href="'/articulo/'+articles[0][0].id">
      <v-row>
        <v-col cols="1" class="d-none d-md-block">
        </v-col>
        <v-col cols="12" md="4">
          <div :style="getDivStylePrincipal(articles[0][0].link)">
          </div>
        </v-col>
        <v-col cols="1" class="d-none d-md-block">
        </v-col>
        <v-col md="6" cols="12">
          <div class="text-center">
        <p class="title-article limited-text-title">{{ articles[0][0].title }}</p>
      <p style="font-family: Noto Sans;
font-size: 25px;
font-weight: 400;
line-height: 34px;
letter-spacing: 0em;
text-align: center;" class="limited-text d-none d-md-block">{{articles[0][0].resumen}}</p>
      </div>
        </v-col>
      </v-row>
      </a>

    </div>
    <v-row>
  <v-col v-for="article in articles[1]" :key="article.id" cols="12" md="3">
    <div class="small-news">
          <a :href="'/articulo/'+article.id">
      <div :style="getDivStyle(article.link)">
      </div>
      <div>
        <h2 class="text-center font-bold limited-text-title" style="font-size: 20px">{{ article.title }}</h2>
        <p class="limited-text" style="font-size: 15px">{{ article.resumen }}</p>
      </div>
    </a>
    </div>

  </v-col>
</v-row>

  </div>
</template>
<script>



import gql from 'graphql-tag'
export default {
  apollo: {
    articles: {
      query: gql` {
       articles_landing:articlesLanding{
        id
        title
        resumen
        principal
        link:linkPhoto
      }
      article_principal:articlesPrincipal{
        id
        title
        resumen
        principal
        link:linkPhoto
      }
    }`,
      update: data => [data.article_principal, data.articles_landing]
    },
  },
    name:"LandingChess",
  data() {
    return {
      articles:null,
    }
  },
  methods: {
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    getDivStyle(link) {
      return {
    'height': '300px',
    'background-image': `url(${link})`,
    'background-size': '100% 100%',  // cambio aquí
    'background-position': 'center',
      };
    },
    getDivStylePrincipal(link) {
      if (window.innerWidth <= 768) {
        return {
          'height': '200px',
          'background-image': `url(${link})`,
          'background-size': '100% 100%',  // cambio aquí
          'background-position': 'center',
        };
      } else {
        return {
          'height': '300px',
          'background-image': `url(${link})`,
          'background-size': '100% 100%',  // cambio aquí
          'background-position': 'center',
            };
      }
    },
  },
}
</script>
<style>
    .container {
      margin: 0 auto;
    }

    .featured-news {
      background-color: #f1f1f1;
      padding: 20px;
      margin-bottom: 20px;
      height: 350px;
    }

    .small-news {
      background-color: gray;
      padding: 20px;
      max-height: 500px;
      height: 500px;
    }

    .limited-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* Número de líneas a mostrar */
  -webkit-box-orient: vertical;
}
        .limited-text-title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Número de líneas a mostrar */
  -webkit-box-orient: vertical;
}

    .title-article{
      font-family: Montserrat;
      font-size: 40px;
      font-weight: 600;
      line-height: 49px;
      letter-spacing: 0em;
      text-align: center;
    }

    @media (max-width: 600px) {
  .title-article{
    font-size: 30px;
  }
}
  </style>